export default __webpack_public_path__ + "static/media/service2.ca0ee416.png";